import { Button, Dropdown, Menu } from "@arco-design/web-react";
import { IconDown } from "@arco-design/web-react/icon";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { Role } from "../../models/Person";
import './RoleDropdown.css';
import { currentThemeName } from "../../theme";

const BASE_ROLE_OPTIONS: Role[] = ['mentee', 'mentor'];

type Props = {
  role: Role;
  onRoleChange: (role: Role) => void;
  showAdminOption?: boolean;
  showGuestOption?: boolean;
}

function roleLabel(role: Role, t: (key: string) => string): string {
  if (role === 'admin') {
    return t('common.admin');
  }
  if (role === 'guest') {
    return t('common.guest');
  }
  if (role === 'mentee') {
    return t('common.mentee');
  }
  return t('common.mentor');
}

export function RoleDropdown({ role, onRoleChange, showAdminOption = false, showGuestOption = false }: Props) {
  const { t } = useTranslation();

  const roleOptions = [
    ...BASE_ROLE_OPTIONS,
    ...(showGuestOption ? ['guest' as Role] : []),
    ...(showAdminOption ? ['admin' as Role] : []),
  ];

  const getDropdownList = () => {
    return roleOptions.map((option) => {
      return (
        <Menu.Item className="role-dropdown__option" onClick={() => onRoleChange(option)} key={option}>
          {roleLabel(option, t)}
        </Menu.Item>
      );
    });
  }

  return (
    <Dropdown
      droplist={<Menu>{getDropdownList()}</Menu>}
      position="bottom"
      trigger="click"
    >
      <Button type='outline' className={classNames("create-user__dropdown-trigger", {
        "create-user__dropdown-trigger--black-theme": currentThemeName === 'black'
      })}>
        {roleLabel(role, t)} <IconDown fontSize={16} />
      </Button>
    </Dropdown>
  );
}
